import { Combobox } from '@ibsys/kit';
import { FC } from 'react';
import { ListTruncationNotice } from '@/shared/ui';

type KmNoteSetPickerProps = {
  options: { value: number; label: string }[];
  /** Сколько наборов пришло с сервера */
  loadedCount: number;
  /** Сколько наборов есть в модели знаний всего; не пришло — о неполноте не сообщается */
  total?: number;
  placeholder: string;
  onSelect: (value: unknown) => void;
};

/**
 * Выбор набора нод знаний из модели знаний. Наборы читаются одним окном, поэтому при
 * усечённой выдаче пользователю говорится, что показаны не все.
 */
export const KmNoteSetPicker: FC<KmNoteSetPickerProps> = ({ options, loadedCount, total, placeholder, onSelect }) => (
  <div className="flex flex-col gap-1">
    <Combobox options={options} onChange={onSelect} placeholder={placeholder} />
    <ListTruncationNotice shown={loadedCount} total={total} className="text-xs" />
  </div>
);
